"use client";

import { createBrowserClient } from "@supabase/ssr";
import type { SupabaseClient } from "@supabase/supabase-js";

/**
 * Browser-side Supabase client for Client Components.
 *
 * Uses the anon key. All reads and writes go through RLS. The browser
 * client is a singleton within the page — creating it on every call
 * would drop the in-memory auth session and realtime subscriptions.
 *
 * Env vars fail loudly. Per `feedback_no_silent_failures`, we'd rather
 * crash the component with a clear message than ship a broken client.
 */
let browserClient: SupabaseClient | null = null;

export function getSupabaseBrowserClient(): SupabaseClient {
  if (browserClient) {
    return browserClient;
  }

  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!url) {
    throw new Error(
      "NEXT_PUBLIC_SUPABASE_URL is not set. Check Vercel env vars.",
    );
  }
  if (!anonKey) {
    throw new Error(
      "NEXT_PUBLIC_SUPABASE_ANON_KEY is not set. Check Vercel env vars.",
    );
  }

  browserClient = createBrowserClient(url, anonKey);
  return browserClient;
}
